/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2020 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import React, { Component } from "react";

const Dialog = require("@react/react-spectrum/Dialog").default;

class OpenLinkDialog extends Component {
  render() {
    const formatMessage = this.props.intl.formatMessage;
    return (
      <Dialog
        title={formatMessage({
          id: "dialog.openLink.title"
        })}
        onConfirm={this.props.openLink}
        onClose={this.props.cancelDialog}
        confirmLabel={formatMessage({ id: "dialog.openLink.action.open" })}
        cancelLabel={formatMessage({ id: "common.cancel" })}
        autoFocusButton="confirm"
        role="document"
      >
        <p>
          {formatMessage(
            {
              id: "dialog.openLink.text"
            },
            {
              url: this.props.url
            }
          )}
        </p>
      </Dialog>
    );
  }
}

export { OpenLinkDialog };
